import { BuyerUserRole } from '@choco-admin/types';
import {
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
  Button,
} from '@heroui/react';
import React from 'react';

import { BuyerSelectOption, ROLE_LABELS } from './types';

interface RoleSelectProps {
  buyer: BuyerSelectOption;
  onRoleChange: (newBuyerOption: BuyerSelectOption) => void;
  disabled?: boolean;
}

export const RoleSelect: React.FC<RoleSelectProps> = ({
  buyer,
  onRoleChange,
  disabled = false,
}) => {
  const currentRole = buyer.metaData?.buyerUserRole || BuyerUserRole.ADMIN;

  const handleRoleChange = (role: string) => {
    const newBuyer: BuyerSelectOption = {
      ...buyer,
      metaData: {
        ...buyer.metaData,
        buyerUserRole: role as BuyerUserRole,
      },
    };
    onRoleChange(newBuyer);
  };

  const roleItems = [
    { key: BuyerUserRole.ADMIN, label: ROLE_LABELS[BuyerUserRole.ADMIN] },
    { key: BuyerUserRole.STAFF, label: ROLE_LABELS[BuyerUserRole.STAFF] },
    {
      key: BuyerUserRole.CONTRIBUTOR,
      label: ROLE_LABELS[BuyerUserRole.CONTRIBUTOR],
    },
    { key: BuyerUserRole.SUPPORT, label: ROLE_LABELS[BuyerUserRole.SUPPORT] },
  ];

  return (
    <Dropdown>
      <DropdownTrigger>
        <Button
          variant="bordered"
          className="justify-between min-w-[140px] cursor-pointer hover:bg-default-100 hover:border-default-300 transition-all duration-200 data-[hover=true]:bg-default-100 data-[hover=true]:border-default-300"
          isDisabled={disabled}
          size="sm"
          endContent={
            <svg
              className="w-4 h-4 text-default-400 transition-transform duration-200 group-data-[open=true]:rotate-180"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          }
        >
          <span className="text-sm font-medium text-foreground">
            {ROLE_LABELS[currentRole]}
          </span>
        </Button>
      </DropdownTrigger>
      <DropdownMenu
        aria-label="Buyer role selection"
        onAction={(key) => handleRoleChange(key as string)}
        selectedKeys={[currentRole]}
        selectionMode="single"
        className="min-w-[140px]"
        itemClasses={{
          base: 'cursor-pointer hover:bg-default-100 data-[hover=true]:bg-default-100 transition-colors duration-150',
          title: 'text-sm font-medium',
        }}
      >
        {roleItems.map((item) => (
          <DropdownItem key={item.key}>
            <span className="text-sm">{item.label}</span>
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};
